import React, {Component} from "react";
import {Loader} from "./Loader";
import "../assets/stylesheets/Alert.scss";

export const AlertType = {
    CONFIRM: 'confirm',
    INFO: 'alert'
};

export default class Alert extends Component {

    static defaultProps = {
        onClick: () => {},
        message: "Successo!",
        btnLabel: "OK",
        cancelLabel: "Cancelar",
        show: false,
        loader: false,
        type: AlertType.INFO,
    };

    handleClick (e) {
        const {onClick} = this.props;
        if (onClick) onClick(e);
    }

    handleConfirm(e) {
        const {onConfirm} = this.props;
        if (onConfirm) onConfirm(e);
    }

    render() {
        const {
            message,
            btnLabel,
            show,
            loader,
            cancelLabel
        } = this.props;

        return (
            <div className={"Alert" + (show ? " show" : "")}>
                <div className={"window" + (show ? " show": "")}>
                    {loader ?
                        <Loader/>
                        :
                        <div>
                            <div className="message">{message}</div>

                            { this.props.type === AlertType.INFO &&
                            <div className="button" onClick={this.handleClick.bind(this)}>{btnLabel}</div>
                            }

                            { this.props.type === AlertType.CONFIRM &&
                            <div className="buttons">
                                <div className="btn-cancel" onClick={this.handleClick.bind(this)}>{cancelLabel}</div>
                                <div className="btn-confirm" onClick={this.handleConfirm.bind(this)}>{btnLabel}</div>
                            </div>
                            }

                        </div>
                    }

                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Alert.js